import AppContext from "AppContext";
import MapaView from "components/MapaView";
import { useCallback, useContext, useEffect, useState } from "react";
import { Button, Container, Modal, ModalBody, Row } from "reactstrap";
import cruzamentoService from "services/CruzamentoService";
import ModalDetalhesCruzamento from "./ModalDetalhesCruzamento";
import ModalVideo from "components/ModalVideo";
import comboService from "services/ComboService";
import { PapelEnum } from "services/PerfilService";
import { GFComboField } from "components/GeneralForm";
import { TipoContratoEnum } from "services/ContratoService";
import { ModalCriarOrdemServico } from "./ModalCriarOrdemServico";

export default function Mapa() {
  const { state } = useContext(AppContext)
  const [cruzamentos, setCruzamentos] = useState([])
  const [cruzamentoSelecionado, setCruzamentoSelecionado] = useState(null)
  const [cruzamentoCriacaoOS, setCruzamentoCriacaoOS] = useState(null)
  const [configModalVideo, setConfigModalVideo] = useState(null)
  const [contratos, setContratos] = useState([])
  const [idContrato, setIdContrato] = useState(state.contrato?.id)
  const [bbox, setBbox] = useState()

  const idTipoPerfil = state?.user?.perfil?.idTipo || 0

  useEffect(() => {
    if (idTipoPerfil == PapelEnum.ADMIN) {
      comboService.contrato().then(res => {
        if (res.success) {
          setContratos(res.data.filter(el => el.tipoContrato == TipoContratoEnum.SEMAFORICO))
        }
      })
    }
  }, [])

  useEffect(() => {
    carregarCruzamentos()
  }, [idContrato, bbox])

  const handleIdle = async (minLat, maxLat, minLng, maxLng) => {
    setBbox({ minLat, maxLat, minLng, maxLng })
  }

  const carregarCruzamentos = async () => {
    console.log('carregarCruzamentos', { idContrato, bbox })
    if (!idContrato || !bbox) return
    const { minLat, maxLat, minLng, maxLng } = bbox
    const res = await cruzamentoService.getByBBox(idContrato, minLat, maxLat, minLng, maxLng)
    if (res.success)
      setCruzamentos(res.data)
  }

  const handleClickCruzamento = async (cruzamento) => {
    setCruzamentoSelecionado(cruzamento)
  }

  return (
    <>
      <Container fluid>
        {idTipoPerfil == PapelEnum.ADMIN && (
          <Row>
            <GFComboField
              colspan={3}
              label="Contrato"
              name="idContrato"
              data={{ idContrato }}
              onChange={(name, value) => setIdContrato(value)}
              options={contratos}
              optionValue="id"
              optionLabel="numero"
              showDefault
            />
          </Row>
        )}
        <MapaView cruzamentos={cruzamentos}
          admin={idTipoPerfil == PapelEnum.ADMIN}
          onClick={handleClickCruzamento}
          onIdle={handleIdle}
        />
      </Container>
      <ModalDetalhesCruzamento
        cruzamento={cruzamentoSelecionado}
        onClosed={() => setCruzamentoSelecionado(null)}
        onClickCamera={(camera) => {
          setConfigModalVideo({
            descricao: `Câmera ${camera.codigo}`,
            videoUrl: camera.url,
          })
        }}
        onClickCriarOS={(cruzamento) => {
          setCruzamentoCriacaoOS(cruzamento)
        }}
      />
      <ModalVideo config={configModalVideo} onClose={() => setConfigModalVideo(null)} />
      <ModalCriarOrdemServico cruzamento={cruzamentoCriacaoOS} onClosed={() => setCruzamentoCriacaoOS(null)} />
    </>
  )
}